import { apiService } from '@/services/api.service';
import { projectMatches } from '@/config/games';

export interface PalettePickEntry {
  id: string;
  path: string | null;
  kind: 'block' | 'item';
  groupId: string;
}

// Palette agrégée (blocks + items), mise en cache pour la session. Une entrée de cache par portée :
// 'all' (tous les groupes, comportement historique) ou l'id du projet quand on veut la MÊME liste que
// les catalogues Blocks/Items, qui ne montrent que les packs du projet actif.
const caches = new Map<string, Promise<PalettePickEntry[]>>();

/**
 * @param projectId limite la palette aux groupes de ce projet (comme les pages Blocks/Items).
 *                  Omis = tous les groupes.
 */
export function loadPackPalette(projectId?: string): Promise<PalettePickEntry[]> {
  const scope = projectId ?? 'all';
  let cached = caches.get(scope);
  if (!cached) {
    cached = (async () => {
      const gr = await apiService.getPacksGroups();
      const all = gr.data?.groups ?? [];
      const groups = projectId ? all.filter((g) => projectMatches(g.projects, projectId)) : all;
      const parts = await Promise.all(
        groups.flatMap((g) => [
          apiService.getPackBlocks(g.id).then((r) => (r.data?.blocks ?? []).map((x) => ({ id: x.identifier, path: x.thumbnail, kind: 'block' as const, groupId: g.id }))),
          apiService.getPackItems(g.id).then((r) => (r.data?.items ?? []).map((x) => ({ id: x.identifier, path: x.iconPath, kind: 'item' as const, groupId: g.id }))),
        ]),
      );
      const seen = new Set<string>();
      return parts.flat().filter((e) => (seen.has(e.id) ? false : (seen.add(e.id), true)));
    })();
    caches.set(scope, cached);
  }
  return cached;
}
